/*
 * @Author: congyisu atui0721@qq.com
 * @Date: 2022-07-13 14:42:34
 * @LastEditors: your Name
 * @LastEditTime: 2022-08-05 10:18:34
 * @FilePath: /finance/src/main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import $axios from "./utils/$axios";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/common.min.css';
import vuescroll from "vuescroll";
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
import "@/utils/directives.js";
import { DonMessage } from "@/utils/messageSingle.js";
Vue.config.productionTip = false;

//Vue.prototype.$echarts = echarts;
// 引入element-ui
Vue.use(ElementUI);

// 引入axios
// Vue.prototype.$axios = $axios;

// 滚动条美化  https://vuescrolljs.yvescoding.org/zh/guide/configuration.html
Vue.use(vuescroll, {
	// 在这里设置全局默认配置
	ops: {
		bar: {
			background: "#cecece",
			onlyShowBarOnScroll: false,
			opacity: 0.5
		},
		scrollPanel: {
			scrollingX: false
		}
	}
});

Vue.prototype.$messageError = name => {
	ElementUI.Message.error({
		showClose: true,
		message: name ? name : '报错啦'
	});
	console.log(name);
};
Vue.prototype.$messageSuccess = name => {
	ElementUI.Message.success({
		showClose: true,
		message: name
	});
};
Vue.prototype.$messageWarning = name => {
	ElementUI.Message.warning({
		showClose: true,
		message: name
	});
};
Vue.prototype.$messageInfo = name => {
	ElementUI.Message.info({
		showClose: true,
		message: name
	});
};
// 金额类添加千分符
Vue.prototype.$thousandSymbols = num => {
  if (num) {
    num = num.toString().replace(/\$|\,/g, "");
    if ("" == num || isNaN(num)) {
      return "Not a Number ! ";
    }
    var sign = num.indexOf("-") > 0 ? "-" : "";
    var cents = num.indexOf(".") > 0 ? num.substr(num.indexOf(".")) : "";
    cents = cents.length > 1 ? cents : "";
    num = num.indexOf(".") > 0 ? num.substring(0, num.indexOf(".")) : num;
    if ("" == cents) {
      if (num.length > 1 && "0" == num.substr(0, 1)) {
        return "Not a Number ! ";
      }
    } else {
      if (num.length > 1 && "0" == num.substr(0, 1)) {
        return "Not a Number ! ";
      }
    }
    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
      num =
        num.substring(0, num.length - (4 * i + 3)) +
        "," +
        num.substring(num.length - (4 * i + 3));
    }
    return sign + num + cents;
  }
};
Vue.prototype.$messageSingle = new DonMessage();
new Vue({
	router,
	store,
	created() {
		this.$nextTick(() => {
		  if (window.self !== window.top) {
			parent.postMessage(
			  {
				type: "load",
			  },
			  "*"
			);
		  }
		});
		/** 考试离考监听 */
		window.addEventListener("focus", () => {
		  try {
			// console.log('----excel--获取焦点----');
			parent.postMessage({ type: "focus" }, "*");
		  } catch (error) {
			console.log(error);
		  }
		});
		window.addEventListener("blur", () => {
		  try {
			// console.log('----excel--失焦----');
			parent.postMessage({ type: "blur" }, "*");
		  } catch (error) {
			console.log(error);
		  }
		});
	  },
	render: h => h(App),
}).$mount("#app");
